import React, { useContext, useState, useEffect } from "react";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";
import { Spin, Button, Affix, Modal, Input, Select } from "antd";

import { Col, Form, Row, Card, Table } from "react-bootstrap";
// import { Button } from "react-bootstrap";
import axios from "axios";
import PsContext from "../../context";
import {
    MOB_ICONS, momentDate, upperCase, S3_BUCKET_HOME_PATH, siteUrl, ParseFloat, groupByMultiple, semesterValue,

} from "../../utils";
import Header from "../header";
import WelcomeProfile from "../home/welcomeProfile";
import ModuleAccess from "../../context/moduleAccess";
import { ServiceUrl } from "../../utils/serviceUrl";
import toast from "react-hot-toast";
import { APP_TYPE, baseUrl } from "../../utils";
// import PrintPdf from "./printpdf";
import PsModalWindow from "../../utils/PsModalWindow";
import { FileOutline } from "antd-mobile-icons";

const ServiceOrganization = (props) => {
    const context = useContext(PsContext);
    const [showAdd, setShowAdd] = useState(false);
    const [profile, setProfile] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [selectStudent, setStudent] = useState([]);
    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [loader, setLoader] = useState(false);
    const [printReport, setPrintReport] = useState(false);
    const [dayOrders, setDayOrders] = useState([]);
    const [myData, setMyData] = useState([]);
    const [dataList, setDataList] = useState([]);
    // const [subjectData, setSubjectData] = useState([]);
    const [serviceorgData, setServiceorgtData] = useState([]);
    const [formData, setFormData] = useState({});
    const [service, setService] = useState([]);
    const [serviceOrg, setServiceOrg] = useState([]);
    const { Option } = Select;
    const [curricularActivities, setCurricularActivities] = useState('');
    const [awards, setAwards] = useState('');

    const [isEnableSave, setIsEnableSave] = useState(true);
    const [selectedCount, setSelectedCount] = useState(0);
    const [allowedCount, setAllowedCount] = useState(0);
    const [isSubjectsLoaded, setIsSubjectsLoaded] = useState(false)
    const [modalVisible, setModalVisible] = useState(false);
    const [bloodGroup, setBloodGroup] = useState([]);
    const [donateBlood, setDonateBlood] = useState([]);
    const [skills, setSkills] = useState([]);
    const [mothertounge, setMothertounge] = useState([]);
    const [langue, setLangue] = useState([]);








    const options = [
        { value: 'afrikaans', label: 'Afrikaans' },
        { value: 'akan', label: 'Akan' },
        { value: 'albanian', label: 'Albanian' },
        { value: 'amharic', label: 'Amharic' },
        { value: 'arabic', label: 'Arabic' },
        { value: 'armenian', label: 'Armenian' },
        { value: 'azerbaijani', label: 'Azerbaijani' },
        { value: 'basque', label: 'Basque' },
        { value: 'belarusian', label: 'Belarusian' },
        { value: 'bengali', label: 'Bengali' },
        { value: 'bosnian', label: 'Bosnian' },
        { value: 'bulgarian', label: 'Bulgarian' },
        { value: 'burmese', label: 'Burmese' },
        { value: 'catalan', label: 'Catalan' },
        { value: 'chichewa', label: 'Chichewa' },
        { value: 'chinese', label: 'Chinese' },
        { value: 'corsican', label: 'Corsican' },
        { value: 'croatian', label: 'Croatian' },
        { value: 'czech', label: 'Czech' },
        { value: 'danish', label: 'Danish' },
        { value: 'dutch', label: 'Dutch' },
        { value: 'english', label: 'English' },
        { value: 'esperanto', label: 'Esperanto' },
        { value: 'estonian', label: 'Estonian' },
        { value: 'filipino', label: 'Filipino' },
        { value: 'finnish', label: 'Finnish' },
        { value: 'french', label: 'French' },
        { value: 'galician', label: 'Galician' },
        { value: 'georgian', label: 'Georgian' },
        { value: 'german', label: 'German' },
        { value: 'greek', label: 'Greek' },
        { value: 'gujarati', label: 'Gujarati' },
        { value: 'haitian', label: 'Haitian Creole' },
        { value: 'hausa', label: 'Hausa' },
        { value: 'hawaiian', label: 'Hawaiian' },
        { value: 'hebrew', label: 'Hebrew' },
        { value: 'hindi', label: 'Hindi' },
        { value: 'hmong', label: 'Hmong' },
        { value: 'hungarian', label: 'Hungarian' },
        { value: 'icelandic', label: 'Icelandic' },
        { value: 'igbo', label: 'Igbo' },
        { value: 'indonesian', label: 'Indonesian' },
        { value: 'irish', label: 'Irish' },
        { value: 'italian', label: 'Italian' },
        { value: 'japanese', label: 'Japanese' },
        { value: 'javanese', label: 'Javanese' },
        { value: 'kannada', label: 'Kannada' },
        { value: 'kazakh', label: 'Kazakh' },
        { value: 'khmer', label: 'Khmer' },
        { value: 'korean', label: 'Korean' },
        { value: 'kurdish', label: 'Kurdish' },
        { value: 'kyrgyz', label: 'Kyrgyz' },
        { value: 'lao', label: 'Lao' },
        { value: 'latin', label: 'Latin' },
        { value: 'latvian', label: 'Latvian' },
        { value: 'lithuanian', label: 'Lithuanian' },
        { value: 'luxembourgish', label: 'Luxembourgish' },
        { value: 'macedonian', label: 'Macedonian' },
        { value: 'malagasy', label: 'Malagasy' },
        { value: 'malay', label: 'Malay' },
        { value: 'malayalam', label: 'Malayalam' },
        { value: 'maltese', label: 'Maltese' },
        { value: 'maori', label: 'Maori' },
        { value: 'marathi', label: 'Marathi' },
        { value: 'mongolian', label: 'Mongolian' },
        { value: 'myanmar', label: 'Myanmar (Burmese)' },
        { value: 'nepali', label: 'Nepali' },
        { value: 'norwegian', label: 'Norwegian' },
        { value: 'odia', label: 'Odia' },
        { value: 'pashto', label: 'Pashto' },
        { value: 'persian', label: 'Persian' },
        { value: 'polish', label: 'Polish' },
        { value: 'portuguese', label: 'Portuguese' },
        { value: 'punjabi', label: 'Punjabi' },
        { value: 'romanian', label: 'Romanian' },
        { value: 'russian', label: 'Russian' },
        { value: 'samoan', label: 'Samoan' },
        { value: 'scots_gaelic', label: 'Scots Gaelic' },
        { value: 'serbian', label: 'Serbian' },
        { value: 'sesotho', label: 'Sesotho' },
        { value: 'shona', label: 'Shona' },
        { value: 'sindhi', label: 'Sindhi' },
        { value: 'sinhala', label: 'Sinhala' },
        { value: 'slovak', label: 'Slovak' },
        { value: 'slovenian', label: 'Slovenian' },
        { value: 'somali', label: 'Somali' },
        { value: 'spanish', label: 'Spanish' },
        { value: 'sundanese', label: 'Sundanese' },
        { value: 'swahili', label: 'Swahili' },
        { value: 'swedish', label: 'Swedish' },
        { value: 'tajik', label: 'Tajik' },
        { value: 'tamil', label: 'Tamil' },
        { value: 'tatar', label: 'Tatar' },
        { value: 'telugu', label: 'Telugu' },
        { value: 'thai', label: 'Thai' },
        { value: 'turkish', label: 'Turkish' },
        { value: 'turkmen', label: 'Turkmen' },
        { value: 'ukrainian', label: 'Ukrainian' },
        { value: 'urdu', label: 'Urdu' },
        { value: 'uyghur', label: 'Uyghur' },
        { value: 'uzbek', label: 'Uzbek' },
        { value: 'vietnamese', label: 'Vietnamese' },
        { value: 'welsh', label: 'Welsh' },
        { value: 'xhosa', label: 'Xhosa' },
        { value: 'yiddish', label: 'Yiddish' },
        { value: 'yoruba', label: 'Yoruba' },
        { value: 'zulu', label: 'Zulu' },
        { value: 'others', label: 'Others' }
    ];

    useEffect(() => {
        loadData();
        loadStudent();
        loadServiceorganization();

    }, []);
    const getDistinctElectiveIds = (data) => {
        // Use Set to store unique elective IDs
        const uniqueElectiveIds = new Set(data.map(item => item.elective_id));

        // Convert Set to array and join with comma to get comma-separated string
        return [...uniqueElectiveIds].join(', ');
    };
    const loadData = () => {
        setLoader(true);

        const form = new FormData();
        form.append('student_uuid', context.user.uuid)
        form.append('course', context.user.course)
        form.append('batch', context.user.batch)
        form.append('semester', context.user.semester)
        axios
            .post(
                ServiceUrl.STUDENTS.LIST_SERVICE, form
            )
            .then((res) => {
                if (res.data.status === "1") {
                    setViewData(res.data.data);

                    if (res.data.data.length > 0) {
                        setAllowedCount(parseInt(res.data.data[0].max_per_student))
                    }

                    loadServiceorg(res.data.data)
                    //  console.log('test', res.data.data);

                } else {
                    Toast.show({ content: res.data.message || "Error" });
                }
                setLoader(false);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoader(false);
            });
    };

    const loadStudent = () => {
        setLoader(true);
        const form = new FormData();
        form.append('student_uuid', context.user.uuid)
        axios.post(ServiceUrl.STUDENTS.LIST_STUDENT_DATA, form)
            .then((res) => {
                if (res.data.status === "1") {
                    setStudent(res.data.data);
                    //console.log('ujs', res.data.data);
                } else {
                    toast.error(res.data.message || "Error");
                }
                setLoader(false);
            })
            .catch((error) => {
                console.error("Error fetching service titles:", error);
                toast.error("Failed to fetch service titles. Please try again later.");
                setLoader(false);
            });
    };

    const loadServiceorganization = () => {
        setLoader(true);

        axios.post(ServiceUrl.STUDENTS.LIST_SERVICE_ORG)
            .then((res) => {
                if (res.data.status === "1") {
                    setService(res.data.data);
                    //  console.log('serviced', res.data.data);

                } else {
                    toast.error(res.data.message || "Error");
                }
                setLoader(false);
            })
            .catch((error) => {
                console.error("Error fetching service titles:", error);
                toast.error("Failed to fetch service titles. Please try again later.");
                setLoader(false);
            });

    };
    const handleProceedButtonClick = () => {
        setModalVisible(true);
    };

    const loadServiceorg = (electiveData) => {
        setLoader(true);
        const form = new FormData();
        form.append('student_uuid', context.user.uuid)
        if (electiveData.length > 0)
            form.append('srv_selection_id', electiveData[0].srv_selection_id)

        axios
            .post(
                ServiceUrl.STUDENTS.LIST_SERIVE_ORG, form
            )
            .then((res) => {
                if (res.data.status === "1") {
                    setServiceorgtData(res.data.data);
                    setSelectedCount(res.data.data.length)

                    if (electiveData.length > 0) {
                        if (parseInt(electiveData[0].max_per_student) <= res.data.data.length)
                            setIsEnableSave(false);
                    }
                    setIsSubjectsLoaded(true)

                    // console.log('testlll', electiveData, res.data.data);

                } else {
                    Toast.show({ content: res.data.message || "Error" });
                }
                setLoader(false);

            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoader(false);
            });
    }

    const handleCheckboxChange = (index) => {
        const isChecked = document.getElementById(`checkbox-${index}`).checked;
        if (isChecked) {
            var selectedData = viewData.find(item => parseInt(item.srv_org_id) == parseInt(index))
            if (allowedCount > selectedSubjects.length) {
                setSelectedSubjects(prevSelected => [...prevSelected, selectedData]);
            }
            else {
                document.getElementById(`checkbox-${index}`).checked = false;
                Toast.show({
                    content: "Allowed Selection Count Exceeds.",
                });
            }
            //console.log('finda', index, selectedData)
        } else {
            setSelectedSubjects(prevSelected =>
                prevSelected.filter((item) => item.srv_org_id !== index)
            );
            // console.log('findb', index, viewData)
        }

    };
    const handleFormSubmit = (e) => {
        e.preventDefault();

        if (selectedSubjects.length > 0) {
            const form = new FormData();
            form.append('student_uuid', context.user.uuid);
            form.append('student_name', context.user.name);
            form.append('action_by_type', 'student');
            form.append('course', context.user.course);
            form.append('batch', context.user.batch);
            form.append('semester', context.user.semester);
            form.append('acyear', context.user.acyear);
            form.append('selected_subjects', JSON.stringify(selectedSubjects));
            form.append('srv_selection_id', selectedSubjects[0].srv_selection_id);
            form.append('max_per_student', selectedSubjects[0].max_per_student);
            form.append('srv_org_name', selectedSubjects[0].srv_org_name);
            form.append('previous_experience', serviceOrg);
            form.append('blood_group', bloodGroup);
            form.append('donate_blood', donateBlood);
            form.append('skills_talents', skills);
            form.append('mothertongue', mothertounge);
            form.append('languages_known', langue);
            form.append('curriculara_activites', curricularActivities);
            form.append('awards_achievements', awards);
            setLoader(true);
            axios.post(ServiceUrl.STUDENTS.SAVE_SERVICE, form)
                .then((res) => {
                    if (res.data.status === "1") {

                        Toast.show({
                            content: res.message || "Saved Successfully",
                        });
                        loadData();
                        setModalVisible(false);
                    } else {
                        Toast.show({
                            content: res.message || "Error",
                        });
                    }
                    setLoader(false);
                })
                .catch((error) => {
                    Toast.show({
                        content: res.message || "Failed to save electives. Please try again.",
                    });
                })
                .finally(() => {
                    setLoader(false);
                });
        } else {
            Toast.show({
                content: res.message || "Nothing Selected to Save",
            });
        }

    };

    // const handleChangeService = (selectedValues) => {
    //     //console.log("Selected values:", selectedValues);
    //     setServiceOrg(selectedValues);
    // };

    const handleBloodGroupChange = (value) => {
        setBloodGroup(value);
    };

    const handleDonateBlood = (value) => {
        setDonateBlood(value);
    };

    const handleSkills = (value) => {
        setSkills(value);
    };
    const handleChangeMotherTounge = (value) => {
        setMothertounge(value);
    };
    const handleKnowLang = (value) => {
        setLangue(value);
    };
    const handleCurricularActivitiesChange = (e) => {
        setCurricularActivities(e.target.value);
    };
    const handleExperinesChange = (e) => {
        setServiceOrg(e.target.value);
    };

    const handleAwardsChange = (e) => {
        setAwards(e.target.value);
    }
    const formFields = [

        {
            fieldName: 'Blood Group',
            datasource: 'students',
            fieldInput: <Form.Control
                as="select"
                size="sm"
                className="fw-bold"
                name="blood_group"
                required
                onChange={(e) => handleBloodGroupChange(e.target.value)}
                defaultValue={selectStudent.length > 0 ? selectStudent[0].blood_group : ''}
                placeholder=""
            >
                <option value="">Select</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>


            </Form.Control>
        },

        {
            fieldName: 'Are you willing to donate blood',
            datasource: 'students',

            fieldInput: (
                <Form.Control
                    as="select"
                    size="sm"
                    className="fw-bold"
                    name="donate_blood"
                    required
                    onChange={(e) => handleDonateBlood(e.target.value)}
                    defaultValue={selectStudent.length > 0 ? selectStudent[0].donate_blood.toString() : '0'}
                >
                    <option value="">Select</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </Form.Control>
            ),
        },
        {
            fieldName: 'Mention your skills and talents in Fine Arts',
            datasource: 'student_services',
            fieldInput: (

                <Select
                    mode="multiple"
                    allowClear
                    showSearch
                    name="skills_talents"
                    style={{ width: '100%' }}
                    placeholder="Select"
                    // onChange={(e) => handleSkills(e.target.value)}
                    onChange={handleSkills}

                    value={skills}
                    optionFilterProp="children"

                >

                    <option value="singing">Singing</option>
                    <option value="dancing">Dancing</option>
                    <option value="folk">Folk</option>
                    <option value="literaryevent">Literary Events </option>
                    <option value="others">Others </option>

                </Select>

            ),
        },

        {
            fieldName: 'Mother Tongue',
            datasource: 'students',
            fieldInput: (
                <Form.Control
                    as="select"
                    size="sm"
                    className="fw-bold"
                    name="mothertongue"
                    required
                    onChange={(e) => handleChangeMotherTounge(e.target.value)}
                    defaultValue={selectStudent.length > 0 ? (selectStudent[0].mothertongue ? selectStudent[0].mothertongue.toLowerCase() : '') : ''}
                >
                    <option value="select">Select</option>
                    <option value="african">Afrikaans</option>
                    <option value="akan">Akan</option>
                    <option value="albanian">Albanian</option>
                    <option value="amharic">Amharic</option>
                    <option value="arabic">Arabic</option>
                    <option value="armenian">Armenian</option>
                    <option value="azerbaijani">Azerbaijani</option>
                    <option value="basque">Basque</option>
                    <option value="belarusian">Belarusian</option>
                    <option value="bengali">Bengali</option>
                    <option value="bosnian">Bosnian</option>
                    <option value="bulgarian">Bulgarian</option>
                    <option value="burmese">Burmese</option>
                    <option value="catalan">Catalan</option>
                    <option value="chichewa">Chichewa</option>
                    <option value="chinese">Chinese</option>
                    <option value="corsican">Corsican</option>
                    <option value="croatian">Croatian</option>
                    <option value="czech">Czech</option>
                    <option value="danish">Danish</option>
                    <option value="dutch">Dutch</option>
                    <option value="english">English</option>
                    <option value="esperanto">Esperanto</option>
                    <option value="estonian">Estonian</option>
                    <option value="filipino">Filipino</option>
                    <option value="finnish">Finnish</option>
                    <option value="french">French</option>
                    <option value="galician">Galician</option>
                    <option value="georgian">Georgian</option>
                    <option value="german">German</option>
                    <option value="greek">Greek</option>
                    <option value="gujarati">Gujarati</option>
                    <option value="haitian">Haitian Creole</option>
                    <option value="hausa">Hausa</option>
                    <option value="hawaiian">Hawaiian</option>
                    <option value="hebrew">Hebrew</option>
                    <option value="hindi">Hindi</option>
                    <option value="hmong">Hmong</option>
                    <option value="hungarian">Hungarian</option>
                    <option value="icelandic">Icelandic</option>
                    <option value="igbo">Igbo</option>
                    <option value="indonesian">Indonesian</option>
                    <option value="irish">Irish</option>
                    <option value="italian">Italian</option>
                    <option value="japanese">Japanese</option>
                    <option value="javanese">Javanese</option>
                    <option value="kannada">Kannada</option>
                    <option value="kazakh">Kazakh</option>
                    <option value="khmer">Khmer</option>
                    <option value="korean">Korean</option>
                    <option value="kurdish">Kurdish</option>
                    <option value="kyrgyz">Kyrgyz</option>
                    <option value="lao">Lao</option>
                    <option value="latin">Latin</option>
                    <option value="latvian">Latvian</option>
                    <option value="lithuanian">Lithuanian</option>
                    <option value="luxembourgish">Luxembourgish</option>
                    <option value="macedonian">Macedonian</option>
                    <option value="malagasy">Malagasy</option>
                    <option value="malay">Malay</option>
                    <option value="malayalam">Malayalam</option>
                    <option value="maltese">Maltese</option>
                    <option value="maori">Maori</option>
                    <option value="marathi">Marathi</option>
                    <option value="mongolian">Mongolian</option>
                    <option value="myanmar">Myanmar (Burmese)</option>
                    <option value="nepali">Nepali</option>
                    <option value="norwegian">Norwegian</option>
                    <option value="odia">Odia</option>
                    <option value="pashto">Pashto</option>
                    <option value="persian">Persian</option>
                    <option value="polish">Polish</option>
                    <option value="portuguese">Portuguese</option>
                    <option value="punjabi">Punjabi</option>
                    <option value="romanian">Romanian</option>
                    <option value="russian">Russian</option>
                    <option value="samoan">Samoan</option>
                    <option value="scots_gaelic">Scots Gaelic</option>
                    <option value="serbian">Serbian</option>
                    <option value="sesotho">Sesotho</option>
                    <option value="shona">Shona</option>
                    <option value="sindhi">Sindhi</option>
                    <option value="sinhala">Sinhala</option>
                    <option value="slovak">Slovak</option>
                    <option value="slovenian">Slovenian</option>
                    <option value="somali">Somali</option>
                    <option value="spanish">Spanish</option>
                    <option value="sundanese">Sundanese</option>
                    <option value="swahili">Swahili</option>
                    <option value="swedish">Swedish</option>
                    <option value="tajik">Tajik</option>
                    <option value="tamil">Tamil</option>
                    <option value="tatar">Tatar</option>
                    <option value="telugu">Telugu</option>
                    <option value="thai">Thai</option>
                    <option value="turkish">Turkish</option>
                    <option value="turkmen">Turkmen</option>
                    <option value="ukrainian">Ukrainian</option>
                    <option value="urdu">Urdu</option>
                    <option value="uyghur">Uyghur</option>
                    <option value="uzbek">Uzbek</option>
                    <option value="vietnamese">Vietnamese</option>
                    <option value="welsh">Welsh</option>
                    <option value="xhosa">Xhosa</option>
                    <option value="yiddish">Yiddish</option>
                    <option value="yoruba">Yoruba</option>
                    <option value="zulu">Zulu</option>
                    <option value="others">Others</option>

                </Form.Control>
            ),
        },
        {
            fieldName: 'Languages known',
            datasource: 'student_services',
            fieldInput: (
                <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Select languages"
                    onChange={handleKnowLang}
                    value={langue}
                    name='languages_known'
                    optionLabelProp="label"
                >
                    {options.map(opt => (
                        <Option key={opt.value} value={opt.value} label={opt.label}>
                            {opt.label}
                        </Option>
                    ))}
                </Select>
            ),
        },
        // {
        //     fieldName: 'Previous Experience',
        //     datasource: 'student_services',

        //     fieldInput: (

        //         <Select
        //             mode="multiple"
        //             allowClear
        //             showSearch
        //             style={{ width: '100%' }}
        //             placeholder="Select"
        //             value={serviceOrg}
        //             onChange={handleChangeService}
        //             optionFilterProp="children"

        //         >
        //             {service.map((item) => (
        //                 <Option key={item.srv_org_id} value={item.srv_org_id}>
        //                     {item.srv_org_name}
        //                 </Option>
        //             ))}
        //         </Select>
        //     ),
        // },
        {
            fieldName: "Previous Experience",
            datasource: 'student_services',
            fieldInput: (
                <Form.Control
                    type="text"
                    size="sm"
                    className="fw-bold"
                    name="previous_experience"
                    placeholder="Previous Experience"
                    value={serviceOrg}
                    onChange={handleExperinesChange}
                />
            ),
        },
        {
            fieldName: "Co curricular Activities if any",
            datasource: 'student_services',
            fieldInput: (
                <Form.Control
                    type="text"
                    size="sm"
                    className="fw-bold"
                    name="curriculara_activites"
                    placeholder="Curricular Activites"
                    value={curricularActivities}
                    onChange={handleCurricularActivitiesChange}
                />
            ),
        },
        {
            fieldName: "Awards received and achievements if any",
            datasource: 'student_services',
            fieldInput: (
                <Form.Control
                    type="text"
                    size="sm"
                    className="fw-bold"
                    name="awards_achievements"
                    placeholder="Awards Achievements"
                    value={awards}
                    onChange={handleAwardsChange}
                />
            ),
        },
    ];
    const extractUniqueDepartments = (data) => {
        const uniqueDepartments = data.reduce((accumulator, currentItem) => {
            // Use department_id as key to maintain uniqueness
            if (!accumulator.has(currentItem.department_id)) {
                accumulator.set(currentItem.department_id, currentItem.department);
            }
            return accumulator;
        }, new Map());

        // Convert Map to an array of objects with department_id and department
        const uniqueDepartmentsArray = Array.from(uniqueDepartments, ([department_id, department]) => ({
            department_id,
            department
        }));

        return uniqueDepartmentsArray;
    };
    const verifyAlrearySelected = (srv_org_id) => {
        var fObject = serviceorgData.find(item => parseInt(item.srv_org_id) === parseInt(srv_org_id))
        // console.log('verify', subject_id, fObject)
        if (fObject)
            return true
        else return false;
    }
    const getDepartmentSubjects = (department_id) => {
        var fData = viewData.filter(item => parseInt(item.department_id) === parseInt(department_id));
        return fData;
    }
    const getCheckbox = (item) => {
        var inputBox = <input
            type="checkbox"
            id={`checkbox-${item.srv_org_id}`}
            name={`checkbox-${item.srv_org_id}`}
            defaultChecked={verifyAlrearySelected(item.srv_org_id)}
            onChange={() => handleCheckboxChange(item.srv_org_id)}
            disabled={verifyAlrearySelected(item.srv_org_id)}
        />
        if (isEnableSave) {
            if (parseInt(item.strength_count) > parseInt(item.student_count)) {

                if (item.male_count && item.female_count) {

                    if (context.user.gender == 'male') {
                        if (parseInt(item.male_count) > parseInt(item.male_count_selected))
                            return inputBox
                        else return null;

                    } else if (context.user.gender == 'female') {
                        if (parseInt(item.female_count) > parseInt(item.female_count_selected))
                            return inputBox
                        else return null;

                    } else return null;
                } else {
                    return inputBox;
                }
            } else return null;

        } else return null;




    }
    const getDepartmentRows = (department_id) => {

        var chkBoxes = [];
        var fData = viewData.filter(item => parseInt(item.department_id) === parseInt(department_id));
        // console.log('depart', department_id, fData)
        fData.forEach(item => {
            if (getCheckbox(item)) {
                chkBoxes.push(
                    <tr>
                        <td>{
                            getCheckbox(item)
                        }
                        </td>
                        <td><span style={{ color: verifyAlrearySelected(item.srv_org_id) ? 'green' : 'black' }}>{item.srv_org_name} </span></td>
                    </tr>
                )
            }
        })
        return chkBoxes;
    }

    const getAlreadySelected = () => {
        var lRow = [];
        serviceorgData.forEach(item => {

            lRow.push(
                <span style={{ color: 'green' }} key={item.srv_org_name}>
                    <span style={{ color: 'green' }}>✅</span>&nbsp;&nbsp;
                    {item.srv_org_name}({item.emp_prefix}. {item.emp_name})
                    <br />
                </span>
            )
        })

        console.log('trs', serviceorgData);
        return lRow;
    }

    return (
        <>
            <Header title="Service Organization" backAction={true} />

            <div className="page-content-wrapper">
                <div className="container py-2 px-0">
                    <WelcomeProfile />
                    <Card>
                        <Card.Body>
                            <Row className="align-items-center">
                                <Col>
                                    <strong style={{ textAlign: "center" }} >Service Organization Selection</strong>
                                </Col>
                            </Row>
                            <Spin spinning={loader}>
                                {isEnableSave && (
                                    <Form
                                        method="post"
                                        noValidate
                                        id="frm_save"
                                        onSubmit={handleFormSubmit}
                                    >
                                        <Row>
                                            <Col>
                                                <table className="table table-bordered">
                                                    <tbody>

                                                        {isSubjectsLoaded && extractUniqueDepartments(viewData).map((item, i) => (
                                                            <React.Fragment key={i}>


                                                                <input
                                                                    type="hidden"
                                                                    name="srv_org_id"
                                                                    value={item.srv_org_id}
                                                                />
                                                                <input
                                                                    type="hidden"
                                                                    name="department_id"
                                                                    value={item.department_id}
                                                                />
                                                                {getDepartmentRows(item.department_id)}
                                                            </React.Fragment>
                                                        ))}

                                                    </tbody>
                                                </table>
                                            </Col>
                                        </Row>

                                        <Row className="mt-3">
                                            <Col md={9}>

                                            </Col>
                                            <Col md={3}>
                                                <Affix offsetBottom={20} offsetRight={20}>

                                                    <Button
                                                        type="primary"
                                                        size="small"
                                                        onClick={handleProceedButtonClick}
                                                    >
                                                        Proceed
                                                    </Button>

                                                </Affix>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                                {!isEnableSave && (getAlreadySelected())}

                            </Spin>
                        </Card.Body>
                    </Card>

                </div>
            </div>


            <Modal
                title="Enrollment Details"
                visible={modalVisible}
                onCancel={() => setModalVisible(false)}
                onOk={handleFormSubmit}

            >
                {formFields.map((field, index) => (
                    <div key={index} className="mb-3">
                        <label className="form-label">{field.fieldName}</label>
                        {field.fieldInput}
                    </div>
                ))}
            </Modal>
        </>
    );
};
export default ServiceOrganization;
